import React from 'react';
import { useTranslation } from 'react-i18next';
import { func, string } from 'prop-types';

// Import components
import { StyledButton } from 'components/views/authentication/login/firebase_auth/style';
import AuthMethodIcon from './AuthMethodIcon';

// Import helpers
import { getButtonColor } from 'components/views/authentication/login/firebase_auth/helpers';

// Import variables
import { LOGIN_SYSTEM_TYPES } from 'helpers/variables';

const { pureott } = LOGIN_SYSTEM_TYPES;

const AuthMethodButton = ({ method, authProvider, onClick, sourceName }) => {
	const { t } = useTranslation();
	const isPureOtt = sourceName === pureott;

	const handleButtonClick = () => onClick(authProvider);

	const { backgroundColor, textColor } = getButtonColor(method, isPureOtt);

	const buttonTitle = isPureOtt
		? t(`common_login_firebase_${method}`)
		: t(`common_login_firebase_${method}_operator`);

	return (
		<StyledButton
			onClick={handleButtonClick}
			data-testid="firebase_auth_button"
			type="button"
			backgroundColor={backgroundColor}
			textColor={textColor}
			isPureOtt={isPureOtt}
		>
			<AuthMethodIcon method={method} isOperator={!isPureOtt} />
			{buttonTitle}
		</StyledButton>
	);
};

AuthMethodButton.propTypes = {
	method: string.isRequired,
	authProvider: string.isRequired,
	onClick: func.isRequired,
	sourceName: string
};

export default AuthMethodButton;
